export default {
    lang_choice_title: 'Welcome',
    lang_choice_subtitle: 'Choose your language',

    more: 'More',
    show_more: 'Show more',
    more_results: 'Show more results',
    loading: 'Loading',
    nofind_movie: 'The movie could not be found.',
    noname: 'Untitled',
    nochoice: 'Not chosen',
    cancel: 'Cancel',
    confirm: 'I confirm',
    sure: 'Are you sure?',
    nodata: 'No data',
    back: 'Back',
    ready: 'Ready',
    close_app_modal: 'Are you sure you want to leave the app?',
    connected_seeds: 'connected',

    search: 'Search',
    search_input: 'Enter text',
    search_empty: 'Search history is empty.',
    search_delete: 'Left - delete',
    search_start_typing: 'Start typing search text.',
    search_searching: 'Search in progress...',
    search_start: 'To start searching',
    search_nofound: 'Nothing was found according to your request.',

    full_genre: 'Genre',
    full_production: 'Production',
    full_date_of_release: 'date of release',
    full_budget: 'Budget',
    full_countries: 'Countries',
    full_like: 'Like',
    full_torrents: 'Torrents',
    full_trailers: 'Trailers',
    full_detail: 'In detail',
    full_notext: 'No description.',
    full_series_release: 'Series release',
    full_next_episode: 'Next',
    full_episode_days_left: 'Days left',
    full_trailer_official: 'Official',
    full_trailer_no_official: 'Informal',
    full_season: 'Season',
    full_episode: 'Episode',
    full_directing: 'Directing',
    full_writing: 'Writing',
    full_keywords: 'Tags',

    settings_cub_sync: 'Synchronization',
    settings_cub_sync_descr: 'Synchronization with the CUB service: Synchronization of your bookmarks, browsing history, tags and timecodes.',
    settings_cub_account: 'Account',
    settings_cub_logged_in_as: 'Logged in as',
    settings_cub_profile: 'Profile',
    settings_cub_sync_btn: 'Synchronize',
    settings_cub_sync_btn_descr: 'Save local bookmarks to CUB account',
    settings_cub_backup: 'Backup',
    settings_cub_backup_descr: 'Save or load backup data',
    settings_cub_logout: 'Sign out',
    settings_cub_signin: 'Authorization',
    settings_cub_not_specified: 'Not specified',
    settings_cub_password: 'Password',
    settings_cub_status: 'Status',
    settings_cub_backup_import: 'Import',
    settings_cub_backup_export: 'Export',
    settings_cub_sync_filters: 'Filters sync',
    settings_cub_sync_calendar: 'Calendar sync',
    settings_cub_sync_quality: 'Quality sync',
    settings_cub_sync_search: 'Search history sync',
    settings_cub_sync_recomends: 'Recommendations sync',
    settings_cub_sync_timecodes: 'Timecode Synchronization',

    settings_input_links: 'Favorites',

    settings_interface_type: 'Lite version',
    settings_interface_size: 'Interface size',
	settings_interface_menu_always: 'Always show the left menu',
    settings_interface_background: 'Background',
    settings_interface_background_use: 'Show background',
    settings_interface_background_type: 'Background type',
    settings_interface_performance: 'Performance',
    settings_interface_animation: 'Animation',
    settings_interface_animation_descr: 'Animation of cards and content',
    settings_interface_attenuation: 'Attenuation',
    settings_interface_attenuation_descr: 'Smooth fading of cards from below and from above',
    settings_interface_scroll: 'Scroll Type',
    settings_interface_view_card: 'Card view type',
    settings_interface_view_card_descr: 'As you scroll the feed, the cards will load gradually or load all',
    settings_interface_lang: 'Interface language',
    settings_interface_lang_reload: 'You need to restart the application, click "OK" to restart.',

    settings_main_account: 'Account',
    settings_main_interface: 'Interface',
    settings_main_player: 'Player',
    settings_main_parser: 'Parser',
    settings_main_torrserver: 'TorrServer',
    settings_main_plugins: 'Extensions',
    settings_main_rest: 'Other',

    settings_rest_start: 'Start page',
    settings_rest_start_descr: 'Which page to start at startup',
    settings_rest_source: 'Source',
    settings_rest_source_use: 'Main source',
    settings_rest_source_descr: 'Where to get information about films',
    settings_rest_tmdb_lang: 'What language to display data from TMDB',
    settings_rest_tmdb_prox: 'Proxy TMDB',
    settings_rest_tmdb_prox_auto: 'Enable proxy automatically',
    settings_rest_tmdb_posters: 'Resolution of TMDB posters',
    settings_rest_screensaver: 'Screensaver',
    settings_rest_screensaver_use: 'Show splash screen when idle',
    settings_rest_screensaver_type: 'Screen saver type',
    settings_rest_helper: 'Hints',
    settings_rest_helper_use: 'Show hints',
    settings_rest_helper_reset: 'Show hints again',
    settings_rest_pages: 'How many pages to keep in memory',
    settings_rest_pages_descr: 'Keeps pages in the state you left them in',
    settings_rest_time: 'Shift time',
    settings_rest_navigation: 'Navigation type',
    settings_rest_keyboard: 'Keyboard type',
    settings_rest_device: 'Device name',
    settings_rest_device_placeholder: 'For example: My Lamp',
    settings_rest_cache: 'Clear cache',
    settings_rest_cache_descr: 'All settings and data will be cleared',
    settings_rest_tmdb_example: 'For example:',
    settings_rest_tmdb_api_descr: 'To get data',
    settings_rest_tmdb_image_descr: 'To get images',
    settings_rest_card_quality: 'Quality marks',
    settings_rest_card_quality_descr: 'Display quality marks on cards',
    settings_rest_card_episodes: 'Episode marks',
    settings_rest_card_episodes_descr: 'Display episode markers on cards',

    settings_parser_use: 'Use parser',
    settings_parser_use_descr: 'Hereby, you agree to accept all responsibility for the use of public links to view torrent and online content.',
    settings_parser_type: 'Parser type for torrents',
    settings_parser_jackett_placeholder: 'For example: 192.168.x',
    settings_parser_jackett_link: 'Link',
    settings_parser_jackett_link_descr: 'Provide a link to the Jackett script',
    settings_parser_jackett_key_placeholder: 'For example: sa0sk83d..',
    settings_parser_jackett_key: 'Api key',
    settings_parser_jackett_key_descr: 'Located in Jackett',
    settings_parser_torlook_type: 'TorLook site parsing method',
    settings_parser_scraperapi_placeholder: 'For example: scraperapi.com',
    settings_parser_scraperapi_link: 'Link to site parser',
    settings_parser_scraperapi_descr: 'Register on the site scraperapi.com, enter the link api.scraperapi.com?api_key=...&url={q}<br>W41.torlook.info will be delivered to {q}',
    settings_parser_search: 'Search',
    settings_parser_search_descr: 'What language to search in?',
    settings_parser_in_search: 'Parser in search',
    settings_parser_in_search_descr: 'Show search results?',
    settings_parser_timeout_title: 'Parser timeout',
    settings_parser_timeout_descr: 'Time in seconds to wait for a response from the server',

    settings_player_type: 'Player type',
    settings_player_type_descr: 'Which player to play',
    settings_player_iptv_type: 'Player type for IPTV',
    settings_player_iptv_type_descr: 'Which player to play IPTV channels',
    settings_player_reset: 'Reset default player',
    settings_player_reset_descr: 'Resets the selected Android player in the application',
    settings_player_path: 'Path to the player',
    settings_player_path_descr: 'Specify the path to the player .exe',
    settings_player_vlc_header: 'VLC Settings',
    settings_player_vlc_api_password: 'Password VLC API',
    settings_player_vlc_api_password_descr: 'Default: 123456',
    settings_player_vlc_fullscreen: 'Launch in fullscreen mode',
    settings_player_normalization: 'Sound normalization',
    settings_player_normalization_descr: 'Normalizes sound to one level, lowers loud sounds and boosts quiet ones.',
    settings_player_next_episode: 'Next episode',
    settings_player_next_episode_descr: 'Automatically switch to the next series after the end of the current one',
    settings_player_timecode: 'Timecode',
    settings_player_timecode_descr: 'Continue from last viewed location',
    settings_player_scale: 'Scaling Method',
    settings_player_scale_descr: 'How to calculate video scaling',
    settings_player_subs: 'Subtitles',
    settings_player_subs_use: 'Turn on',
    settings_player_subs_use_descr: 'Always turn on subtitles after starting a video',
    settings_player_subs_size: 'The size',
    settings_player_subs_size_descr: 'Screen size of subtitles',
    settings_player_subs_stroke_use: 'Use edging',
    settings_player_subs_stroke_use_descr: 'Subtitles will be outlined in black for better readability',
    settings_player_subs_backdrop_use: 'Use an underlay',
    settings_player_subs_backdrop_use_descr: 'Subtitles will be displayed on a translucent backing to improve readability',
    settings_player_quality: 'Default video quality',
    settings_player_quality_descr: 'Preferred video quality for viewing',
    settings_player_hls_title: 'Processing the .m3u8 stream',
    settings_player_hls_descr: 'Do not touch this parameter if you do not know why it is.',

    settings_plugins_notice: 'To apply the plugin, you need to restart the application',
    settings_plugins_add: 'Add Plugin',
    settings_plugins_add_descr: 'To delete an added plugin, hold or double-click the (OK) key on it',
    settings_plugins_install: 'Install Plugin',
    settings_plugins_install_descr: 'Install a plugin from the list of available',

    settings_server_link: 'Use link',
    settings_server_links: 'Links',
    settings_server_placeholder: 'For example: 192.168.X',
    settings_server_link_one: 'Main Link',
    settings_server_link_one_descr: 'Specify the main link to the TorrServer script',
    settings_server_link_two: 'Additional link',
    settings_server_link_two_descr: 'Provide an additional link to the TorrServer script',
    settings_server_additionally: 'Additionally',
    settings_server_client: 'Embedded client',
    settings_server_client_descr: 'Use the built-in TorrServer JS client, otherwise the system one starts.',
    settings_server_base: 'Save to database',
    settings_server_base_descr: 'The torrent will be added to the TorrServer database',
    settings_server_preload: 'Use prefetch buffer',
    settings_server_preload_descr: 'Wait for TorrServer\'s preload buffer to fill before playing',
    settings_server_auth: 'Authorization',
    settings_server_password_use: 'Password login',
    settings_server_login: 'Login',
    settings_server_password: 'Password',
    settings_server_not_specified: 'Not specified',

    torent_nohash_reasons: 'The reasons',
    torent_nohash_reason_one: 'TorServer was unable to download the torrent file',
    torent_nohash_reason_two: 'Reply from TorServer',
    torent_nohash_reason_three: 'Link',
    torent_nohash_do: 'What to do?',
    torent_nohash_do_one: 'Check if you configured Jackett correctly',
    torent_nohash_do_two: 'Private sources may not provide a link to the file',
    torent_nohash_do_three: 'Make sure Jackett can download the file too',
    torent_nohash_do_four: 'Write to our telegram group: @lampa_group',
    torent_nohash_do_five: 'Specify which movie, which distribution and, if possible, a photo of this distribution',

    torrent_error_text: 'Failed to connect to TorrServer. Let\'s quickly go through the list of possible problems and check everything.',
    torrent_error_step_1: 'Is TorrServer running',
    torrent_error_step_2: 'Dynamic IP',
    torrent_error_step_3: 'Protocol and Port',
    torrent_error_step_4: 'Antivirus blocking',
    torrent_error_step_5: 'Check for availability',
    torrent_error_step_6: 'Still doesn\'t work',
    torrent_error_info_1: 'Make sure you have launched TorrServer on the device where it is installed.',
    torrent_error_info_2: 'A common mistake, the IP address of the device with TorrServer has changed. Make sure that the IP address you entered - {ip} - matches the address of the device on which TorrServer is installed.',
    torrent_error_info_3: 'To connect to TorrServer, you must specify the protocol http:// at the beginning and port :8090 at the end of the address. Make sure there is a port after the IP address, your current address is {ip}',
    torrent_error_info_4: 'Frequent occurrence, antivirus or firewall can block access by IP address, try disabling antivirus and firewall.',
    torrent_error_info_5: 'On any other device on the same network, open the {ip} address in a browser and check if the TorrServer web interface is available.',
    torrent_error_info_6: 'If, after all the checks, a connection error still occurs, try restarting TorrServer and the Internet adapter.',
    torrent_error_info_7: 'If the problem persists, write to the Telegram group @lampa_group with the text (vi3000 does not connect to TorrServer after all checks, the current address is {ip})',
    torrent_error_start: 'Start verification',
    torrent_error_nomatrix: 'Failed to verify Matrix version',
    torrent_error_made: 'Performed',
    torrent_error_from: 'from',
    torrent_error_next: 'Further',
    torrent_error_complite: 'To complete',
    torrent_error_connect: 'Connection error',

    torrent_install_need: 'Requires TorrServer',
    torrent_install_text: 'TorrServer is an application that allows you to view content from torrent files online.<br><br>More detailed information on installation can be found in the Telegram groups below.',
    torrent_install_contact: 'Telegram groups',

    torrent_item_bitrate: 'Bitrate',
    torrent_item_seeds: 'Seeds',
    torrent_item_grabs: 'Leechers',
    torrent_item_mb: 'Mbps',

    torrent_serial_episode: 'Series',
    torrent_serial_season: 'Season',
    torrent_serial_date: 'Exit',

    torrent_get_magnet: 'Requesting a magnet link',
    torrent_remove_title: 'Delete',
    torrent_remove_descr: 'The torrent will be removed from your list',

    torrent_parser_any_one: 'Any',
    torrent_parser_any_two: 'Any',
    torrent_parser_no_choice: 'Not chosen',
    torrent_parser_yes: 'Yes',
    torrent_parser_no: 'No',
    torrent_parser_quality: 'Quality',
    torrent_parser_subs: 'Subtitles',
    torrent_parser_voice: 'Translation',
    torrent_parser_tracker: 'tracker',
    torrent_parser_year: 'Year',
    torrent_parser_season: 'Season',
    torrent_parser_sort_by_seeders: 'By distributors',
    torrent_parser_sort_by_size: 'To size',
    torrent_parser_sort_by_name: 'by name',
    torrent_parser_sort_by_tracker: 'By source',
    torrent_parser_sort_by_date: 'By date',
    torrent_parser_sort_by_viewed: 'Viewed',
    torrent_parser_voice_dubbing: 'Dubbing',
    torrent_parser_voice_polyphonic: 'Polyphonic',
    torrent_parser_voice_two: 'Two-voiced',
    torrent_parser_voice_amateur: 'Amateur',
    torrent_parser_reset: 'Reset filter',
    torrent_parser_empty: 'Failed to get results',
    torrent_parser_no_hash: 'Failed to get HASH, try reloading TorrServer',
    torrent_parser_added_to_mytorrents: 'added to "My torrents"',
    torrent_parser_add_to_mytorrents: 'Add to "My torrents"',
    torrent_parser_label_title: 'Flag',
    torrent_parser_label_descr: 'Flag a hand with a flag (viewed)',
    torrent_parser_label_cancel_title: 'Uncheck',
    torrent_parser_label_cancel_descr: 'Remove the mark from the distribution (viewed)',
    torrent_parser_timeout: 'Timeout expired',
    torrent_parser_nofiles: 'Failed to extract suitable files',
    torrent_parser_set_link: 'Specify a link for parsing',
    torrent_parser_request_error: 'Request error',
    torrent_parser_magnet_error: 'Failed to get magnet link',
    torrent_parser_no_responce: 'The parser is not responding to the request',
    torrent_parser_torlook_fallback_search_notification: 'Jackett parser is not available or the connection settings are incorrect. Searching Torlook...',

    about_text: 'The application is completely free and uses public links to get information about videos, new releases, popular movies, etc. All available information is used solely for educational purposes, the application does not use its own servers to distribute information.',
    about_channel: 'Our channel',
    about_group: 'Group',
    about_version: 'Version',
    about_donate: 'Donat',

    title_watched: 'You watched',
    title_settings: 'Settings',
    title_collections: 'Collections',
    title_company: 'Company',
    title_actors: 'Actors',
    title_actor: 'Actor',
    title_actress: 'Actress',
    title_person: 'Person',
    title_persons: 'Persons',
    title_comments: 'Comments',
    title_torrents: 'Torrents',
    title_trailers: 'Trailers',
    title_watch: 'Watch',
    title_error: 'Error',
    title_links: 'Links',
    title_choice: 'Choose',
    title_main: 'Home',
    title_book: 'Bookmarks',
    title_like: 'Like',
    title_wath: 'Later',
    title_history: 'Browsing history',
    title_mytorrents: 'My torrents',
    title_last: 'Last',
    title_action: 'Action',
    title_producer: 'Producer',
    title_collection: 'Collection',
    title_recomendations: 'Recommendations',
    title_similar: 'Similar',
    title_about: 'About the application',
    title_timetable: 'Schedule',
    title_relises: 'Digital releases',
    title_catalog: 'Catalog',
    title_category: 'Category',
    title_parser: 'Parser',
    title_type: 'Type of',
    title_rating: 'Rating',
    title_country: 'Country',
    title_year: 'Year',
    title_genre: 'Genre',
    title_filter: 'Filter',
    title_notice: 'Notifications',
    title_files: 'Files',
    title_now_watch: 'Watching now',
    title_latest: 'Last addition',
    title_continue: 'Continue browsing',
    title_recomend_watch: 'We recommend to see',
    title_new_episodes: 'New episodes',
    title_popular: 'Popular',
    title_popular_movie: 'Popular films',
    title_popular_tv: 'Popular TV shows',
    title_new_this_year: 'New this year',
    title_hight_voite: 'Highly rated',
    title_new: 'New',
    title_trend_day: 'Today in trend',
    title_trend_week: 'Trending for the week',
    title_upcoming: 'Watch in cinemas',
    title_top_movie: 'Top movies',
    title_top_tv: 'Top series',
    title_tv_today: 'On air today',
    title_this_week: 'This week',
    title_in_top: 'Top',
    title_out: 'Exit',
    title_out_confirm: 'Yes, get out',
    title_continue_two: 'Proceed',
    title_choice_language: 'Choose a language',
    title_subscribe: 'Subscribe',
    title_subscribes: 'Subscriptions',
    title_unsubscribe: 'Unsubscribe',
    title_language: 'Original language',

    subscribe_success: 'You have successfully subscribed',
    subscribe_error: 'An error occurred while subscribing, please try again later',
    subscribe_noinfo: 'Failed to retrieve information, please try again later',

    company_headquarters: 'Headquarters',
    company_homepage: 'Website',
    company_country: 'Country',

    country_ad: 'Andorra',
    country_ae: 'UAE',
    country_af: 'Afghanistan',
    country_al: 'Albania',
    country_am: 'Armenia',
    country_ao: 'Angola',
    country_ar: 'Argentina',
    country_at: 'Austria',
    country_au: 'Australia',
    country_aw: 'Aruba',
    country_az: 'Azerbaijan',
    country_bа: 'Bosnia & Herzegovina',
    country_bd: 'Bangladesh',
    country_be: 'Belgium',
    country_bg: 'Bulgaria',
    country_bh: 'Bahrain',
    country_bi: 'Burundi',
    country_bj: 'Benin',
    country_bo: 'Bolivia',
    country_br: 'Brazil',
    country_bs: 'Bahamas',
    country_bt: 'Bhutan',
    country_bw: 'Botswana',
    country_by: 'Belarus',
    country_ca: 'Canada',
    country_ch: 'Switzerland',
    country_cl: 'Chile',
    country_cm: 'Cameroon',
    country_cn: 'China',
    country_co: 'Colombia',
    country_cr: 'Costa Rica',
    country_cu: 'Cuba',
    country_cv: 'Cape Verde',
    country_cy: 'Cyprus',
    country_cz: 'Czech Republic',
    country_de: 'Germany',
    country_dj: 'Djibouti',
    country_dk: 'Denmark',
    country_do: 'Dominican Republic',
    country_dz: 'Algeria',
    country_ec: 'Ecuador',
    country_ee: 'Estonia',
    country_eg: 'Egypt',
    country_es: 'Spain',
    country_et: 'Ethiopia',
    country_fi: 'Finland',
    country_fo: 'Faroe Islands',
    country_fr: 'France',
    country_ga: 'Gabon',
    country_gb: 'United Kingdom',
    country_ge: 'Georgia',
    country_gh: 'Ghana',
    country_gl: 'Greenland',
    country_gp: 'Guadeloupe',
    country_gr: 'Greece',
    country_gt: 'Guatemala',
    country_hk: 'Hong Kong',
    country_hr: 'Croatia',
    country_ht: 'Haiti',
    country_hu: 'Hungary',
    country_id: 'Indonesia',
    country_ie: 'Ireland',
    country_il: 'Israel',
    country_in: 'India',
    country_iq: 'Iraq',
    country_ir: 'Iran',
    country_is: 'Iceland',
    country_it: 'Italy',
    country_jm: 'Jamaica',
    country_jo: 'Jordan',
    country_jp: 'Japan',
    country_ke: 'Kenya',
    country_kg: 'Kyrgyzstan',
    country_kh: 'Cambodia',
    country_kp: 'North Korea',
    country_kr: 'South Korea',
    country_kz: 'Kazakhstan',
    country_kw: 'Kuwait',
    country_la: 'Laos',
    country_lb: 'Lebanon',
    country_li: 'Liechtenstein',
    country_lk: 'Sri Lanka',
    country_lr: 'Liberia',
    country_lt: 'Lithuania',
    country_lu: 'Luxembourg',
    country_lv: 'Latvia',
    country_ly: 'Libya',
    country_ma: 'Morocco',
    country_mc: 'Monaco',
    country_md: 'Moldova',
    country_me: 'Montenegro',
    country_mk: 'Macedonia',
    country_mm: 'Myanmar',
    country_mn: 'Mongolia',
    country_mo: 'Macau',
    country_mt: 'Malta',
    country_mu: 'Mauritius',
    country_mv: 'Maldives',
    country_mw: 'Malawi',
    country_mx: 'Mexico',
    country_my: 'Malaysia',
    country_mz: 'Mozambique',
    country_na: 'Namibia',
    country_ne: 'Niger',
    country_ng: 'Nigeria',
    country_ni: 'Nicaragua',
    country_nl: 'Netherlands',
    country_no: 'Norway',
    country_np: 'Nepal',
    country_nz: 'New Zealand',
    country_om: 'Oman',
    country_pa: 'Panama',
    country_pe: 'Peru',
    country_pg: 'Papua New Guinea',
    country_ph: 'Philippines',
    country_pk: 'Pakistan',
    country_pl: 'Poland',
    country_pr: 'Puerto Rico',
    country_ps: 'Palestinian Territory',
    country_pt: 'Portugal',
    country_py: 'Paraguay',
    country_qa: 'Qatar',
    country_ro: 'Romania',
    country_rs: 'Serbia',
    country_ru: 'Russia',
    country_rw: 'Rwanda',
    country_sa: 'Saudi Arabia',
    country_sd: 'Sudan',
    country_se: 'Sweden',
    country_sg: 'Singapore',
    country_si: 'Slovenia',
    country_sk: 'Slovakia',
    country_sn: 'Senegal',
    country_su: 'USSR',
    country_sv: 'El Salvador',
    country_sy: 'Syria',
    country_th: 'Thailand',
    country_tj: 'Tajikistan',
    country_tm: 'Turkmenistan',
    country_tn: 'Tunisia',
    country_tr: 'Turkey',
    country_tw: 'Taiwan',
    country_tz: 'Tanzania',
    country_ua: 'Ukraine',
    country_ug: 'Uganda',
    country_us: 'USA',
    country_uy: 'Uruguay',
    country_uz: 'Uzbekistan',
    country_ve: 'Venezuela',
    country_vn: 'Viet Nam',
    country_xk: 'Kosovo',
    country_ws: 'Samoa',
    country_ye: 'Yemen',
    country_yu: 'Yugoslavia',
    country_za: 'South Africa',
    country_zm: 'Zambia',
    country_zw: 'Zimbabwe',

    filter_clarify: 'Clarify',
    filter_clarify_two: 'Refine Search',
    filter_set_name: 'Specify title',
    filter_sorted: 'Sort',
    filter_filtred: 'Filter',
    filter_any: 'Any',
    filter_combinations: 'Combinations',
    filter_alt_names: 'Other names',
    filter_rating_from: 'from',
    filter_rating_to: 'to',

    filter_lang_af: 'Afrikaans',
    filter_lang_ar: 'Arabic',
    filter_lang_az: 'Azerbaijani',
    filter_lang_ba: 'Bashkir',
    filter_lang_be: 'Belarusian',
    filter_lang_bg: 'Bulgarian',
    filter_lang_bn: 'Bengali',
    filter_lang_bs: 'Bosnian',
    filter_lang_ca: 'Catalan',
    filter_lang_ce: 'Chechen',
    filter_lang_cs: 'Czech',
    filter_lang_da: 'Danish',
    filter_lang_de: 'German',
    filter_lang_el: 'Greek',
    filter_lang_en: 'English',
    filter_lang_es: 'Spanish',
    filter_lang_et: 'Estonian',
    filter_lang_fa: 'Persian',
    filter_lang_fi: 'Finnish',
    filter_lang_fr: 'French',
    filter_lang_ga: 'Irish',
    filter_lang_gl: 'Galician',
    filter_lang_gn: 'Guarani',
    filter_lang_he: 'Hebrew',
    filter_lang_hi: 'Hindi',
    filter_lang_hr: 'Croatian',
    filter_lang_hu: 'Hungarian',
    filter_lang_hy: 'Armenian',
    filter_lang_id: 'Indonesian',
    filter_lang_is: 'Icelandic',
    filter_lang_it: 'Italian',
    filter_lang_ja: 'Japanese',
    filter_lang_ka: 'Georgian',
    filter_lang_kk: 'Kazakh',
    filter_lang_ko: 'Korean',
    filter_lang_ks: 'Kashmiri',
    filter_lang_ku: 'Kurdish',
    filter_lang_ky: 'Kirghiz',
    filter_lang_lt: 'Lithuanian',
    filter_lang_lv: 'Latvian',
    filter_lang_mi: 'Maori',
    filter_lang_mk: 'Macedonian',
    filter_lang_mn: 'Mongolian',
    filter_lang_mt: 'Maltese',
    filter_lang_ne: 'Nepali',
    filter_lang_nl: 'Dutch (Nederlands)',
    filter_lang_no: 'Norwegian',
    filter_lang_pa: 'Punjabi',
    filter_lang_pl: 'Polish',
    filter_lang_ps: 'Pushto',
    filter_lang_pt: 'Portuguese',
    filter_lang_ro: 'Romanian',
    filter_lang_ru: 'Russian',
    filter_lang_si: 'Sinhalese',
    filter_lang_sk: 'Slovak',
    filter_lang_sl: 'Slovenian',
    filter_lang_sm: 'Samoan',
    filter_lang_so: 'Somali',
    filter_lang_sq: 'Albanian',
    filter_lang_sr: 'Serbian',
    filter_lang_sv: 'Swedish',
    filter_lang_sw: 'Swahili',
    filter_lang_ta: 'Tamil',
    filter_lang_tg: 'Tajik',
    filter_lang_th: 'Thai',
    filter_lang_tk: 'Turkmen',
    filter_lang_tr: 'Turkish',
    filter_lang_tt: 'Tatar',
    filter_lang_ur: 'Urdu',
    filter_lang_uk: 'Ukrainian',
    filter_lang_uz: 'Uzbek',
    filter_lang_vi: 'Vietnamese',
    filter_lang_yi: 'Yiddish',
    filter_lang_zh: 'Chinese',

    filter_genre_ac: 'Action',
    filter_genre_ad: 'Adventures',
    filter_genre_mv: 'Cartoon',
    filter_genre_cm: 'Comedy',
    filter_genre_cr: 'Crime',
    filter_genre_dc: 'Documentary',
    filter_genre_dr: 'Drama',
    filter_genre_fm: 'Family',
    filter_genre_fe: 'Fantasy',
    filter_genre_hi: 'Story',
    filter_genre_ho: 'Horror',
    filter_genre_mu: 'Music',
    filter_genre_de: 'Detective',
    filter_genre_md: 'Melodrama',
    filter_genre_fa: 'Fiction',
    filter_genre_tv: 'TV film',
    filter_genre_tr: 'Thriller',
    filter_genre_mi: 'Military',
    filter_genre_ve: 'Western',
    filter_genre_aa: 'Action & Adventure',
    filter_genre_ch: 'Children\'s',
    filter_genre_nw: 'News',
    filter_genre_rs: 'Reality show',
    filter_genre_hf: 'Sci-Fi and Fantasy',
    filter_genre_op: 'Soap opera',
    filter_genre_tc: 'Talk show',
    filter_genre_mp: 'War and Politics',

    empty_title: 'Empty',
    empty_text: 'Nothing found for your filter, please refine your filter.',
    empty_title_two: 'It\'s empty here',
    empty_text_two: 'The list is currently empty.',

    menu_main: 'Home',
    menu_movies: 'Movies',
    menu_tv: 'Series',
    menu_catalog: 'Catalog',
    menu_filter: 'Filter',
    menu_collections: 'Collections',
    menu_relises: 'Releases',
    menu_anime: 'Anime',
    menu_bookmark: 'Bookmarks',
    menu_like: 'Like',
    menu_time: 'Later',
    menu_history: 'History',
    menu_timeline: 'Schedule',
    menu_torrents: 'Torrents',
    menu_settings: 'Settings',
    menu_about: 'Information',
    menu_console: 'Console',
    menu_multmovie: 'Cartoons',
    menu_multtv: 'Animated series',

    plugins_catalog_work: 'Working plugins',
    plugins_catalog_work_descr: 'Plugins that work exactly in the lamp.',
    plugins_catalog_popular: 'Popular plugins among users',
    plugins_catalog_popular_descr: 'Installation from unknown sources may cause the application to work incorrectly.',
    plugins_online: 'View online',
    plugins_check_fail: 'Failed to test the functionality of the plugin. However, this does not mean that the plugin does not work. Reload the application to see if the plugin is loading.',
    plugins_need_reload: 'To apply the plugin, you need to restart the application',
    plugins_install: 'Install',
    plugins_install_ready: 'This plugin is already installed.',
    plugins_installed: 'Installations',
    plugins_load_from: 'Loaded from CUB',
    plugins_ok_for_check: 'Click (OK) to test the plugin',
    plugins_no_loaded: 'When loading the application, some plugins could not be loaded',

    time_viewed: 'Viewed',
    time_from: 'from',
    time_reset: 'Reset timecode',

    settings_clear_cache: 'Cache and data cleared',
    settings_user_links: 'Custom Link',
    settings_for_local: 'For local TorrServer',
    settings_add: 'Add',
    settings_remove: 'Delete',
    settings_this_value: 'present value',
    settings_added: 'Added',
    settings_removed: 'Removed',

    settings_param_player_inner: 'vi3000',
    settings_param_player_outside: 'External',
    settings_param_player_inner_tvos: 'Internal',
    settings_param_yes: 'Yes',
    settings_param_no: 'No',
    settings_param_interface_size_small: 'Smaller',
    settings_param_interface_size_normal: 'Normal',
    settings_param_interface_size_bigger: 'More',
    settings_param_poster_quality_low: 'Low',
    settings_param_poster_quality_average: 'Average',
    settings_param_poster_quality_high: 'High',
    settings_param_parse_directly: 'Directly',
    settings_param_parse_api: 'Through the website API',
    settings_param_background_complex: 'Complex',
    settings_param_background_simple: 'Simple',
    settings_param_background_image: 'Picture',
    settings_param_link_use_one: 'Main',
    settings_param_link_use_two: 'Additional',
    settings_param_link_use_both: 'Both',
    settings_param_subtitles_size_small: 'small',
    settings_param_subtitles_size_normal: 'Ordinary',
    settings_param_subtitles_size_bigger: 'Large',
    settings_param_screensaver_nature: 'Nature',
    settings_param_torrent_lang_orig: 'Original',
    settings_param_torrent_lang_ru: 'Russian',
    settings_param_player_timecode_again: 'Start over',
    settings_param_player_timecode_continue: 'Proceed',
    settings_param_player_timecode_ask: 'To ask',
    settings_param_player_scale_method: 'Calculate',
    settings_param_player_hls_app: 'Systemic',
    settings_param_player_hls_js: 'Program',
    settings_param_card_view_load: 'Upload',
    settings_param_card_view_all: 'Show all',
    settings_param_navigation_remote: 'Remote controller',
    settings_param_navigation_mouse: 'Remote control with mouse',
    settings_param_keyboard_lampa: 'vi3000',
    settings_param_keyboard_system: 'Systemic',

    helper_keyboard: 'After entering the value, press the "Back" button to save',
    helper_torrents: 'Hold down the (OK) key to bring up the context menu',
    helper_cleared: 'Success, tooltips will be shown again.',
    helper_torrents_view: 'Hold down the (OK) key to reset the timecode and display the menu',

    fav_sync_title: 'Bookmark sync',
    fav_sync_text: 'Your favorite bookmarks with you. Connect synchronization and view on any device. <br><br>To do this, register on the site {site}, create a profile and log in to the application.',
    fav_sync_site: 'Website',
    fav_remove_title: 'Remove from history',
    fav_remove_descr: 'Delete selected card',
    fav_clear_title: 'Clear the history',
    fav_clear_descr: 'Delete all cards from history',
    fav_clear_label_title: 'Clear labels',
    fav_clear_label_descr: 'Clear View Tags',
    fav_clear_time_title: 'Clear Timecodes',
    fav_clear_time_descr: 'Clear all timecodes',
    fav_label_cleared: 'Marks cleared',
    fav_time_cleared: 'Timecodes cleared',

    timetable_empty: 'This section will display the release dates of new episodes.',

    player_quality: 'Quality',

    player_quality_premium: 'Subscription',
    player_flow: 'Flow',
    player_tracks: 'Audio tracks',
    player_disabled: 'Disabled',
    player_unknown: 'Unknown',
    player_subs: 'Subtitles',
    player_size_default_title: 'Default',
    player_size_default_descr: 'Default video size',
    player_size_cover_title: 'Expand',
    player_size_cover_descr: 'Expands video to full screen',
    player_size_fill_title: 'Fill',
    player_size_fill_descr: 'Fit video to full screen',
    player_size_s115_title: 'Zoom 115%',
    player_size_s115_descr: 'Enlarge video by 115%',
    player_size_s130_title: 'Zoom 130%',
    player_size_s130_descr: 'Enlarge video by 130%',
    player_size_v115_title: 'Vertical 115%',
    player_size_v115_descr: 'Enlarge video by 115%',
    player_size_v130_title: 'Vertical 130%',
    player_size_v130_descr: 'Enlarge video by 130%',
    player_video_size: 'Video size',
    player_playlist: 'Playlist',
    player_error_one: 'Failed to decode video',
    player_error_two: 'Video not found or corrupted',
    player_start_from: 'Continue browsing from',
    player_not_found: 'Player not found',
    player_lauch: 'Launch player',
    player_speed_default_title: 'Plain',
    player_speed_two_descr: 'Play without sound',
    player_video_speed: 'Playback speed',
    player_share_title: 'Share',
    player_share_descr: 'Play this video on another device',
    player_normalization_power_title: 'Normalization power',
    player_normalization_smooth_title: 'Normalization speed',
    player_normalization_step_low: 'Low',
    player_normalization_step_medium: 'Average',
    player_normalization_step_hight: 'High',
    player_youtube_no_played: 'Sorry, this video is not available in your region and may have been blocked or removed.',
    player_youtube_start_play: 'To start playing the video, click the "Play" button.',

    broadcast_open: 'Open card on another device',
    broadcast_play: 'Choose the device to watch on',

    card_new_episode: 'New series',
    card_book_remove: 'Remove from bookmarks',
    card_book_add: 'To bookmarks',
    card_book_descr: 'Look in the menu (Bookmarks)',
    card_like_remove: 'Remove from favorites',
    card_like_add: 'Like',
    card_like_descr: 'Look at the menu (Like)',
    card_wath_remove: 'Remove from expected',
    card_wath_add: 'Watch Later',
    card_wath_descr: 'See the menu (Later)',
    card_history_remove: 'Remove from history',
    card_history_add: 'Into history',
    card_history_descr: 'Look in the menu (History)',

    keyboard_listen: 'Speak, I\'m listening...',
    keyboard_nomic: 'No microphone access',

    notice_new_quality: 'New quality available',
    notice_quality: 'Quality',
    notice_new_episode: 'New series',
    notice_none: 'You don\'t have any notifications yet, register at <b>{site}</b> to follow new episodes and releases.',
    notice_in_quality: 'As',
    notice_none_account: 'You don\'t have any notifications yet, bookmark the series and wait for notifications of new episodes.',
    notice_none_system: 'You currently have no notifications. We will be sure to notify you when new notifications become available.',

    copy_link: 'Copy video link',
    copy_secuses: 'Link copied to clipboard',
    copy_error: 'Error copying link',

    account_sync_to_profile: 'All bookmarks will be moved to the profile',
    account_sync_secuses: 'All bookmarks have been successfully transferred',
    account_profiles: 'Profiles',
    account_profiles_empty: 'Failed to get list of profiles',
    account_authorized: 'Authorized',
    account_logged_in: 'You are logged in',
    account_login_failed: 'Login failed',
    account_login_wait: 'Waiting for login',
    account_profile_main: 'General',
    account_export_secuses: 'Export completed successfully',
    account_export_fail: 'Export error',
    account_import_secuses: 'Import completed successfully',
    account_import_fail: 'Import error',
    account_imported: 'imported',
    account_reload_after: 'reboot after 5 sec.',
    account_create: 'Discover more opportunities with a CUB account. Register at <span class="account-modal__site">{site}</span> and get access to sync your bookmarks, timecodes and other CUB account features.',
    account_premium_more: 'Learn more about CUB Premium',
    account_limited: 'You have reached the maximum limit. Increase the limit with a CUB Premium account. Learn more at <span class="account-modal__site">{site}/premium</span>',

    account_code_enter: 'Enter a six-digit code',
    account_code_error: 'Perhaps you entered an incorrect or outdated code',
    account_code_wrong: 'Perhaps you entered an incorrect format',
    account_code_where: 'Go to the <span class="account-add-device__site">{site}/add</span> website and enter the code provided there.',
    account_code_input: 'Enter code',
    account_device_auth_needed: 'Authorization required to watch',
    account_device_go_to_bot: 'Go to Telegram bot',
    account_device_select_devices: 'Devices -> Add',
    account_device_enter_code: 'and enter this code:',
    account_device_waiting: 'Waiting for authorization...',
    account_device_code_expired: 'Code expired. Try again.',
    premium_need_title: 'Subscription required',
    premium_need_text: 'Purchase a subscription to watch',
    premium_open_bot: 'Open Telegram bot',
    premium_tap_pay: 'and tap 💳 Subscription',
    premium_scan_qr: 'Scan the QR code to open the bot',
    settings_cub_signin_button: 'Sign in',

    network_noconnect: 'No network connection',
    network_404: 'The requested page was not found. [404]',
    network_401: 'Authorization failed',
    network_500: 'Internal Server Error. [500]',
    network_parsererror: 'The requested JSON parsing failed.',
    network_timeout: 'Request timed out.',
    network_abort: 'The request has been aborted.',
    network_error: 'Unknown error',

    size_zero: '0 Byte',
    size_byte: 'Byte',
    size_kb: 'KB',
    size_mb: 'MB',
    size_gb: 'GB',
    size_tb: 'TB',
    size_pp: 'PB',

    speed_bit: 'bps',
    speed_kb: 'Kbps',
    speed_mb: 'Mbps',
    speed_gb: 'Gbps',
    speed_tb: 'Tbps',
    speed_pp: 'Pbps',

    month_1: 'January',
    month_2: 'February',
    month_3: 'March',
    month_4: 'April',
    month_5: 'May',
    month_6: 'June',
    month_7: 'July',
    month_8: 'August',
    month_9: 'September',
    month_10: 'October',
    month_11: 'November',
    month_12: 'December',

    day_1: 'Monday',
    day_2: 'Tuesday',
    day_3: 'Wednesday',
    day_4: 'Thursday',
    day_5: 'Friday',
    day_6: 'Saturday',
    day_7: 'Sunday',

    month_1_e: 'January',
    month_2_e: 'February',
    month_3_e: 'March',
    month_4_e: 'April',
    month_5_e: 'May',
    month_6_e: 'June',
    month_7_e: 'July',
    month_8_e: 'August',
    month_9_e: 'September',
    month_10_e: 'October',
    month_11_e: 'November',
    month_12_e: 'December',

    week_1: 'Mon',
    week_2: 'Tue',
    week_3: 'Wed',
    week_4: 'Thu',
    week_5: 'Fri',
    week_6: 'Sat',
    week_7: 'Sun',

    extensions_enable: 'Turn on',
    extensions_disable: 'Disable',
    extensions_check: 'Check status',
    extensions_install: 'Install',
    extensions_info: 'Information',
    extensions_edit: 'Edit',
    extensions_change_name: 'Change name',
    extensions_change_link: 'Change link',
    extensions_remove: 'Delete',
    extensions_set_name: 'Enter plugin name',
    extensions_set_url: 'Enter plugin url',
    extensions_ready: 'This plugin is already installed',
    extensions_no_info: 'Without information',
    extensions_no_name: 'Untitled',
    extensions_worked: 'Worker',
    extensions_no_plugin: 'Plugin not verified',
    extensions_add: 'Add Plugin',
    extensions_from_memory: 'Installed in memory',
    extensions_from_cub: 'Installed from CUB',
    extensions_from_popular: 'Popular plugins',
    extensions_from_lib: 'Plugin Library',
    extensions_from_connected: 'Connected plugins',

    settings_webos_launcher: 'Application launch',
    settings_webos_launcher_add_device: 'Install as starter app',
    settings_webos_launcher_remove_device: 'Remove from starter spplications',
    player_normalization: 'Normalization',
    change_source_on_cub: 'Change source to CUB',
    settings_param_jackett_interview_all: 'All',
    settings_param_jackett_interview_healthy: 'Available only',
    settings_parser_jackett_interview: 'Poll trackers',
    title_ongoing: 'Ongoings',
    title_pgrating: 'Age limit',

    settings_interface_card_interfice: 'Card interface',
    settings_interface_card_poster: 'Show poster',
    title_card: 'Card',
    settings_param_card_interface_old: 'Old',
    settings_param_card_interface_new: 'New',
    title_seasons: 'Seasons',
    title_episodes: 'Episodes',
    title_rewiews: 'Reviews',
    settings_interface_glass: 'Glass',
    settings_interface_glass_descr: 'Show interface in glassy style',
    settings_interface_black_style: 'Black style',

    plugins_remove: 'Remove plugins',
    plugins_add_success: 'Plugin connected successfully',
    settings_reset: 'Reset',
    title_channel: 'Channel',

    input_detection_touch: 'Want to switch to touch control?',
    input_detection_mouse: 'Want to switch to mouse control?',
    input_detection_remote: 'Want to switch to remote control?',

    settings_interface_hide_outside_the_screen: 'Hide cards off screen',
    settings_interface_hide_outside_the_screen_descr: 'This will speed up UI rendering and improve performance',

    https_text: 'You are using the HTTPS protocol, in this protocol the lamp does not work correctly. For the correct operation of the lamp, use the address with the HTTP protocol',

    extensions_hpu_best: 'Popular',
    extensions_hpu_recomend: 'Recommended',
    extensions_hpu_theme: 'Themes',
    extensions_hpu_screensaver: 'Screensaver',
    extensions_hpu_video: 'Video',
    extensions_hpu_control: 'Control',
    extensions_hpu_other: 'Miscellaneous',
    extensions_hpu_: 'Other',

    title_author: 'Author',

    title_buffer: 'Buffer',
    settings_rest_screensaver_time: 'After how many minutes to start the screensaver',

    time_h: 'h.',
    time_m: 'm.',
    time_s: 's.',

    settings_param_glass_easy: 'Transparent',
    settings_param_glass_medium: 'Semitransparent',
    settings_param_glass_blacked: 'Blacked out',

    settings_interface_glass_opacity: 'Glass transparency',
    torrent_error_check_no_auth: 'The server responded to the request, but the authorization failed',
    settings_interface_card_cover: 'Show cover',

    title_upcoming_episodes: 'Upcoming episode releases',
    title_recent_episodes: 'Recent episode releases',
    settings_rest_cache_images: 'Image cache',
    settings_rest_cache_images_descr: 'Cache posters and backgrounds to local storage',

    settings_player_rewind_title: 'Rewind',
    settings_player_rewind_descr: 'Rewind interval in seconds',

    settings_interface_card_reactions: 'Show reactions',
    title_look: 'Looking',
    title_scheduled: 'Scheduled',
    title_viewed: 'Viewed',
    title_thrown: 'Thrown',
    title_reactions: 'Reactions',
    reactions_none: 'No reactions',
    reactions_fire: 'Great',
    reactions_nice: 'Nice',
    reactions_think: 'Interesting',
    reactions_bore: 'Boring',
    reactions_shit: 'Bad',
    reactions_ready: 'You have already left a reaction',
    settings_player_launch_trailers: 'Trailer Player',
    title_continued: 'To be continued',
    title_language_short: 'Language',

    speedtest_connect: 'connection',
    speedtest_test: 'testing',
    speedtest_ready: 'ready',
    speedtest_button: 'Test Speed',

    termsofuse_t_01: 'Terms of Use',
    termsofuse_t_02: 'vi3000 is a convenient tool for exploring the latest news in the film industry, including movies, TV shows, cartoons, and other information. To obtain information about movies, an open-source website, themoviedb.org, is used.',
    termsofuse_t_03: 'Content',
    termsofuse_t_04: 'vi3000 utilizes the API (application programming interface) from the themoviedb.org catalog to retrieve information about movies and TV shows, as well as to view associated media files such as posters, trailers, and more.',
    termsofuse_t_05: 'The themoviedb.org API allows the vi3000 application to access a database of movies and TV shows, providing the ability to search and view media file information.',
    termsofuse_t_06: 'The interaction between the vi3000 application and themoviedb.org occurs through API requests that are sent from the vi3000 application to the themoviedb.org servers to obtain information and media files. Themoviedb.org processes the requests and sends the requested data back to the vi3000 application.',
    termsofuse_t_07: 'Thus, thanks to the use of the themoviedb.org API, the vi3000 application provides users with access to an extensive database of movies and TV shows, while complying with the terms of use and restrictions set by the rights holder.',
    termsofuse_t_08: 'Extensions',
    termsofuse_t_09: 'Extensions are a powerful tool provided for the vi3000 application, allowing users to enhance its capabilities, add additional functionality, and modify content according to their needs.',
    termsofuse_t_10: 'However, it should be noted that users install extensions at their own risk. All consequences arising from the use of extensions are the responsibility of the user. Users are advised to exercise caution when installing and using extensions, carefully evaluating their reliability and security.',
    termsofuse_t_11: 'Copyright Infringements',
    termsofuse_t_12: 'If you discover any copyright infringement in the vi3000 application, you should contact the developers of the vi3000 application. You can use the contacts provided in the vi3000 application to do so. However, it is important to note that the vi3000 application uses the API from the themoviedb.org catalog, which provides open access to information about movies and TV shows. This means that the information displayed in the vi3000 application is publicly available and does not infringe on copyright.',
    termsofuse_t_13: 'If you believe that the vi3000 application still contains content that violates your copyright, you can contact the rights holder of that content and request its removal from the themoviedb.org website. In turn, the vi3000 application can remove content upon receiving a proper copyright infringement notification.',
    settings_rest_protocol_use: 'Secure connection',
    settings_rest_protocol_descr: 'Use HTTPS protocol',
    install_app_apk_title: 'How to install vi3000 on Android',
    install_app_apk_text: 'We noticed that you use MediaStationX to run vi3000 on Android. We recommend installing vi3000 as an APK app. This will ensure more stable operation and access to all the app\'s features. <br><br>Go to the <span class="account-modal__site">@lampa_group</span> Telegram group to download the latest APK and installation instructions.',
    install_app_apk_qr: 'Scan the QR code to download the vi3000 APK',
    copy_link_buffer: 'Copy link',

    tv_status_returning_series: 'Returning series',
    tv_status_planned: 'Planned',
    tv_status_in_production: 'In Production',
    tv_status_ended: 'Ended',
    tv_status_canceled: 'Canceled',
    tv_status_pilot: 'Pilot',

    tv_status_released:'Released',
    tv_status_rumored:'Rumored',
    tv_status_post_production:'Post Production',

    title_last_year: 'Last year',

    title_reset: 'Reboot',
    back_to_card: 'Return to card',

    premiere_author_recomend_1: 'Order pizza and get ready for some excitement.',
    premiere_author_recomend_2: 'The party is just getting started.',
    premiere_author_recomend_3: 'Get ready for some adrenaline.',
    premiere_author_recomend_4: 'Ready for an unforgettable evening?',
    premiere_author_recomend_5: 'I recommend watching it.',
    premiere_title: 'Premiere',

    settings_clear_cache_only: 'Cache Cleared',
    settings_rest_cache_only: 'Only Cache',
    settings_rest_cache_only_descr: 'Basic settings will be preserved',
    settings_rest_cache_all: 'Cache and Data',
    settings_rest_cache_all_descr: 'All settings and data will be cleared',
    settings_rest_cache_calculate: 'How much memory is left',

    title_left:'Left',

    account_export_fail_500: 'Unknown error',
    account_export_fail_610: 'You have exceeded the limit for today',
    account_export_fail_200: 'Database error, please try again later',
    account_export_fail_600: 'Error, failed to upload the file',
    account_export_fail_620: 'Error, file not transmitted',

    title_parental_control: 'Parental Control',
    settings_parental_control_param_time_always: 'Always',
    settings_parental_control_param_time_once: 'Once',
    settings_parental_control_param_time_10: 'In 10 minutes',
    settings_parental_control_param_time_20: 'In 20 minutes',
    settings_parental_control_param_time_30: 'In 30 minutes',
    settings_parental_control_param_time_60: 'In 1 hour',
    settings_parental_control_param_time_120: 'In 2 hours',
    settings_parental_control_change_pin: 'Change PIN',
    settings_parental_control_demand_title: 'When to Prompt',
    settings_parental_control_demand_descr: 'After how much time to prompt for the PIN',
    settings_parental_control_enabled: 'Enabled',
    settings_parental_control_disabled: 'Disabled',
    parental_control_input_new_code: 'Enter new PIN code',
    parental_control_confirm_new_code: 'Confirm PIN code',
    parental_control_no_match_code: 'PIN code does not match the previous code',
    parental_control_input_code: 'Enter PIN code',
    parental_control_input_error: 'You entered an incorrect PIN code',
    title_worth_rewatch: 'Worth a rewatch',

    ad_disable: 'Turn off ads for 299 ₽/month — pay in Telegram.',
    ad_after: 'Advertising via',
    ad: 'Advertising',
    ad_skip: 'Skip',
    ad_continue_after: 'Viewing will start in',

    ad_fork_title: 'How will you watch?',
    ad_fork_subtitle: 'The library stays free. This choice is only about ads.',
    ad_fork_free_title: 'Free',
    ad_fork_free_text: 'One video before the movie. No interruptions inside.',
    ad_fork_free_btn: 'Watch with ads',
    ad_fork_paid_title: '299 ₽ per month',
    ad_fork_paid_text: 'Zero ads. Up to 5 devices per account.',
    ad_fork_paid_day: 'That is 10 ₽ a day',
    ad_fork_paid_btn: 'Turn off ads',
    ad_fork_footer: 'This is how we pay for the servers. Thank you for being here.',
    ad_fork_note: 'Payment in Telegram · no auto-renewal · cancel anytime',
    ad_bar_text: '10 ₽ a day — and you will never see it again',
    ad_not_now: 'Not now',
    ad_turn_off: 'Turn off',
    ad_qr_title: 'Turn off ads',
    ad_qr_text: 'Point your phone camera at the QR code — our Telegram bot with payment will open.',
    ad_qr_close: 'Close',
    subscription_activated: 'Subscription active — ads disabled',
    settings_parser_prowlarr_link_descr: 'Provide a link to the Prowlarr server',
    settings_parser_prowlarr_key_descr: 'Located in the Prowlarr settings tab in the general category',
    settings_player_torrent_type: 'Player type for torrents',
    settings_player_torrent_type_descr: 'Which player to play torrents',

    full_crew: 'More',
    full_editing: 'Editing',
    full_creator: 'Creator',
    player_normalization_step_none: 'Zero',

    settings_cub_backup_export_descr: 'Save settings to the cloud',
    settings_cub_backup_import_descr: 'Restore settings from the cloud',

    settings_interface_sound: 'System sounds',
    settings_interface_sound_play: 'Transitions',
    settings_interface_sound_level: 'Volume level',
    settings_interface_advanced_animation: 'Advanced animation',

    confirm_open_player: 'Another device is requesting access to the player. Do you want to play the video?',

    pincode_use_remote: 'Use the remote control to enter the code by pressing the arrows to select the desired number.',
    pincode_use_toggle: 'Press and hold the OK button to change the layout.',

    settings_parental_control_where: 'Where to request a PIN code',
    title_fire: 'Fire!',
    title_top_100: 'Top 100',

    player_normalization_type_title: 'Normalization Type',
    player_normalization_type_all: 'All',
    player_normalization_type_up: 'Only Increase',
    player_normalization_type_down: 'Only Decrease',
    storage_quota_exceeded: 'Storage quota exceeded. Clear cache and try again.',
    settings_cub_domain: 'Primary domain',

    title_ai_assistant: 'AI Assistant',
    title_facts: 'Interesting Facts',
    ai_search_start_typing: 'Ask the AI Assistant what movies you want to find. For example: "Movies about space"',
    ai_search_limit: 'Request limit exceeded. Please try again later. With a CUB Premium subscription, limits will be increased, and you won’t have to wait!',
    ai_subscribe_title: 'Unlock More Opportunities with AI',
    ai_subscribe_descr: 'Subscribe to CUB Premium and increase the number of requests to AI. Together with AI, we’ll find the best movies for you.',

    dmca_title: 'Content blocked',
    dmca_descr: 'This material is not available for viewing. It has been blocked at the request of the copyright holder in accordance with copyright law.',

    loading_progress_step_0: 'Preparation',
    loading_progress_step_1: 'Loading languages',
    loading_progress_step_2: 'Searching for mirrors',
    loading_progress_step_3: 'Preparing extensions',
    loading_progress_step_4: 'Almost there',
    loading_progress_step_5: 'Coming soon',

    install_extension_rule_1: 'Installing a third-party plugin',
    install_extension_rule_2: 'Plugins are created by independent developers, and VI3000 does not verify their content. By installing them, you agree that:',
    install_extension_rule_3: '- Some plugins may request access to your data or work with unverified sources.',
    install_extension_rule_4: '- If the plugin you install violates copyright or other laws, you are fully responsible for its use.',
    install_extension_rule_5: '- Install only plugins from trusted sources. If you have any doubts about the security or legality of a plugin, it is better to refrain from installing it.',
    install_extension_rule_6: 'VI3000 does not support or endorse plugins related to pirated content.',
    install_extension_rule_7: 'By proceeding, you confirm that you understand these risks.',
    ad_plugin: 'Advertisement from the plugin',

    terminal_title: 'Terminal',
    terminal_no_access: 'No access',
    terminal_confirm: 'Allow',
    terminal_deny: 'Deny',
    terminal_update: 'Update',
    terminal_code: 'Access code',
    terminal_text: 'You are requesting access to the terminal. Developers may gain access to your device and control it. This can be useful for diagnostics and troubleshooting, but may also pose a security risk. Please make sure you trust the developers before granting access. <br><br>You can disable this feature at any time by clicking the "Deny" button.',

    
    title_anons: 'Announcement',
    title_developer: 'Developer',
    title_navigation: 'Navigation',
    title_page: 'Page',
    title_person_about: 'About',
    account_qr_premium: 'Scan the QR code to learn more about CUB Premium',
    account_qr_code: 'Scan the QR code to receive a device linking code',
    account_qr_create: 'Scan the QR code to create an account',
    account_add_device_title: 'Add Device',
    account_add_device_text: 'Go to <span class="account-modal__site">{site}/add</span> to get a code for adding a device.',
    account_none_title: 'Don’t have an account yet?',
    account_none_include_1: 'Bookmarks and watch history are stored in the cloud',
    account_none_include_2: 'Sync between devices',
    account_none_include_3: 'Notifications about new episodes and releases',
    account_none_include_4: 'Create multiple profiles under one account',
    account_premium_include_1: 'Increased number of bookmarks',
    account_premium_include_2: 'Extended watch history',
    account_premium_include_3: 'More timecodes available',
    account_premium_include_4: 'Number of profiles per account',
    empty_subscribes_title: 'Your translation subscriptions',
    empty_subscribes_text: 'Just subscribe to your favorite translation and we’ll notify you when a new episode is released.',
    empty_history_title: 'Your watch history',
    empty_history_text: 'Your watch history will appear here.',
    empty_bookmark_title: 'Your favorites',
    empty_bookmark_text: 'Add movies and TV shows you like to favorites to quickly find them in this section.',
    empty_mytorrents_title: 'Your torrents',
    empty_mytorrents_text: 'Torrents you’ve downloaded via TorServer will appear here.',
    developer_param_enabled: 'Developer Mode',
    developer_param_nopremium: 'Disable CUB Premium',
    developer_param_nodemo: 'Disable Demo Mode',
    developer_param_ads: 'Show Ads',
    developer_param_fps: 'Show FPS',
    developer_trigger_help_1: 'Almost guessed it :)',
    developer_trigger_help_2: 'Just a little more :)',
    developer_trigger_help_3: 'Are you sure you want to enter Developer Mode?',
    developer_trigger_help_4: 'Developer Mode activated',
    settings_param_navigation_touch: 'Sensor',
    account_discuss_add_qr: 'Scan the QR code',
    account_discuss_add_title: 'Want to leave a comment?',
    account_discuss_add_text: 'Scan the QR code to go to the app and add a comment on this movie or TV series. <br><br> - Take your phone or tablet <br> - Open the camera <br> - Point to the QR code <br> - Follow the link that appears on the screen',
    account_discuss_added: 'Thank you for your comment!',
    account_discuss_added_ready: 'You have already left a comment on this movie or TV series.',
    remote_helper_long: 'Hold the (OK) button to open the menu',
    account_premium: 'Unlock new horizons with a CUB Premium account! Enjoy increased limits and enhanced service functionality. Visit <span class="account-modal__site">{site}/premium</span> and learn more about the benefits of a premium account.',
    player_segments_title: 'Segments',
    player_segments_descr: 'Skip intro and other parts of the video',
    player_segments_ad_title: 'Ads',
    player_segments_skip_title: 'Intro and other',
    player_segments_value_none: 'Do not skip',
    player_segments_value_auto: 'Auto skip',
    player_segments_value_user: 'Custom',
    player_segments_skiped: 'Segment skipped',
    subscribe_info: 'In the Subscriptions section, you\'ll see all your translation subscriptions. You\'ll receive a notification when a new episode with your selected translation is released.',
    no_watch_history: 'No browsing history',

    settings_request_caching_use: 'Request Caching',
    settings_request_caching_descr: 'Cache API requests to speed up the interface and reduce data usage.',

    account_profile_child: 'Child',
    account_profile_add: 'Add profile',
    account_profile_name: 'Profile name',
    account_profile_created: 'Profile successfully created',
    account_profile_limited: 'The maximum profile limit has been reached: {count}',
    account_profile_info: 'You can manage profiles in your account settings. To do this, go to <span class="account-modal__site">{site}/profiles</span>',
    player_youtube_no_support: 'Your device does not support YouTube video playback, please check your internet connection.',
    title_channels: 'Channels',
    title_best_of_2000: 'Golden 2000s',
    title_best_of_2010: 'Hits of the 2010s',
    title_best_of_2015: 'Modern Classics',
    title_comedy_of_2000: 'Laughter of the 2000s',
    title_comedy_of_2010: 'Humor of the 2010s',
    title_comedy_of_2015: 'Modern Comedies',

    filter_keyword_sequel: 'Sequel',
    filter_keyword_based_comic: 'Based on Comics',
    filter_keyword_space: 'Space',
    filter_keyword_survival: 'Survival',
    filter_keyword_zombie: 'Zombie',
    filter_keyword_school: 'School',
    filter_keyword_revenge: 'Revenge',
    filter_keyword_detective: 'Detective',
    filter_keyword_robots: 'Robots',
    filter_keyword_vampires: 'Vampires',
    filter_keyword_aliens: 'Aliens',
    filter_keyword_police: 'Police',
    filter_keyword_reincarnation: 'Reincarnation',
    filter_keyword_spy: 'Spy',
    filter_keyword_disaster: 'Catastrophe', 
    filter_keyword_christmas: 'Christmas',

    dmca_title_lgbt: 'Content Restricted',
    dmca_descr_lgbt: 'Viewing is unavailable in your region as it may contain LGBT content. Such material may be prohibited or restricted in some countries.',

    settings_lgbt_content_block: 'Block LGBT content',

    // todo:
    adult_content_title: 'Adult Content',
    adult_content_text_warning: 'Content may contain adult material that may be inappropriate for some viewers.',
    adult_content_text_modal: 'This film or series is marked as containing adult content. You must be 18 years of age or older to view this material. Please confirm that you are of legal age to continue viewing.',

    adult_content_confirm: 'I am 18 or older',
    adult_content_deny: 'I am under 18',
}
